export enum ListItemEvents {
  CANCEL = 'cancel',
  SAVE = 'save',
  CLICK_OUTSIDE = 'clickOutside',
  ITEM_CLICK = 'itemClick',
}
